export default __webpack_public_path__ + "static/media/nopic.ce500788.png";